import { Form } from '@rocketseat/unform';
import {
  Breadcrumbs,
  Button,
  CanAccess,
  Dropdown,
  Modal,
  SearchBox,
  Text,
  Title,
  WrapperFlex,
} from '@unimed-fesp/components';
import { format, isAfter } from 'date-fns';
import produce from 'immer';
import React, { useEffect, useState } from 'react';
import {
  MdAdd,
  MdFileDownload,
  MdFilterList,
  MdInfo,
  MdSearch,
} from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { WarningToast } from '../../components/molecules/Toast';
import history from '../../services/history';
import theme from '../../styles/theme';

import { TipoPerfilUsuarioEnum } from '../../enums';

import { Container } from './styles';

import FadeIn from '../../components/atoms/FadeIn';

import LoadingSpinner from '../../components/molecules/LoadingSpinning';
import StatusFilter from '../../components/molecules/StatusFilter';
import FilterExtendsSegundaVia from '../../components/organisms/FilterExtendsSegundaVia';
import ModalPesquisaBeneficiarioSegundaVia from '../../components/organisms/ModalPesquisaBeneficiarioSegundaVia';
import TabTableListaSegundaVia from '../../components/organisms/TabTableListaSegundaVia';
import { Creators as RequisicaoActions } from '../../store/ducks/requisicao';

function SegundaVia() {
  const dispatch = useDispatch();

  const { usuario } = useSelector((state) => state.auth);
  const {
    postProcessarSegundaVia,
    postRelatorioSegundaVia,
    getPermissaoSegundaVia,
  } = useSelector((state) => state.requisicao);

  const contractorOrAdm =
    usuario.role !== 'Adm' ? usuario.codigoContratante : null;

  const filterExtendsParams = {
    page: 0,
    count_per_page: 10,
    is_administrator: usuario.role === 'Adm',
    beneficiary_name: null,
    contractor_code: contractorOrAdm,
    term_number: null,
    status: null,
    modality: null,
    start_requisition_create_at: null,
    end_requisition_create_at: null,
    start_requisition_processing_date: null,
    end_requisition_processing_date: null,
  };
  const paginationTabParams = {
    pageNumber: 1,
    pageSize: 10,
  };
  const reportExtendsParams = {
    is_administrator: usuario.role === 'Adm',
    beneficiary_name: null,
    contractor_code: null,
    status: null,
    status_string: null,
    modality: null,
    term_number: null,
    requisition_ids: null,
    start_requisition_create_at: null,
    end_requisition_create_at: null,
    start_requisition_processing_date: null,
    end_requisition_processing_date: null,
  };
  const processExtendsParams = {
    requisitions: null,
    processing_date: null,
    user_id: usuario.idUsuarioLogado,
  };

  const [processParams, setProcessParams] = useState(processExtendsParams);
  const [filterParams, setFilterParams] = useState(filterExtendsParams);
  const [paginationParams, setPaginationParams] = useState(paginationTabParams);
  const [reportParams, setReportParams] = useState(reportExtendsParams);
  const [openFilterExtends, setOpenFilterExtends] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [cancelFilterExtendsOpen, setCancelFilterExtendsOpen] = useState(false);
  const [status, setStatus] = useState();
  const [
    isOpenModalPesquisarBeneficiario,
    setIsOpenModalPesquisarBeneficiario,
  ] = useState(false);

  const [reportsItems, setReportItems] = useState([]);
  const [isCheckedAllPages, setIsCheckedAllPages] = useState(false);
  const [openModalProcess, setOpenModalProcess] = useState({
    warning: false,
    message: '',
    textHeader: '',
    onClickOk: null,
  });

  const [searchBoxActive, setSearchBoxActive] = useState(false);
  const [dataProcessamento, setDataProcessamento] = useState(new Date());

  const optionsButtonRelatorios = [
    {
      onClickOption: () => handleDropdownItemClick('Resumido'),
      text: 'Resumido (CSV)',
    },
    {
      onClickOption: () => handleDropdownItemClick('Detalhado'),
      text: 'Detalhado (XLSX)',
    },
  ];

  function ProcessDuplicate() {
    const formattedData = format(dataProcessamento, 'yyyy-MM-dd');
    const currentTime = format(new Date(), 'HH:mm:ss');

    const newDateProcess = `${formattedData} ${currentTime}`;

    const newProcessParams = produce(processParams, (draft) => {
      draft.processing_date = newDateProcess;
      draft.requisitions = reportsItems.map((item) => {
        return {
          beneficiaryId: item.beneficiaryId,
          requisitionId: item.requisitionId,
        };
      });
    });

    dispatch(
      RequisicaoActions.postSegundaViaProcessarRequest(newProcessParams)
    );
  }

  function handleDataProcessamento(e) {
    if (e.target) return;
    setDataProcessamento(e);
  }

  function cleanFilterParams() {
    setFilterParams(filterExtendsParams);
  }

  function handleData(data) {
    if (
      isAfter(data.dataSolicitacaoAte, new Date()) ||
      isAfter(data.dataSolicitacaoDe, new Date()) ||
      isAfter(data.dataProcessamentoAte, new Date()) ||
      isAfter(data.dataProcessamentoDe, new Date())
    ) {
      toast.error(
        <WarningToast>
          A Pesquisa por Data não deve ser superior à data atual.
        </WarningToast>
      );
      return false;
    }
    const newFilterParams = produce(filterParams, (draft) => {
      draft.page = 0;
      draft.count_per_page = 10;
      draft.beneficiary_name = inputValue || null;
      draft.contractor_code = contractorOrAdm || data.codigoContratante || null;
      draft.modality = data.modalidade || null;
      draft.status = status === 99 ? null : status;
      draft.term_number = data.termo ? data.termo : null;
      draft.start_requisition_create_at = data.dataSolicitacaoDe
        ? format(data.dataSolicitacaoDe, 'MM-dd-yyyy 00:00:00')
        : null;
      draft.end_requisition_create_at = data.dataSolicitacaoAte
        ? format(data.dataSolicitacaoAte, 'MM-dd-yyyy 00:00:00')
        : null;
      draft.start_requisition_processing_date = data.dataProcessamentoDe
        ? format(data.dataProcessamentoDe, 'MM-dd-yyyy 00:00:00')
        : null;
      draft.end_requisition_processing_date = data.dataProcessamentoAte
        ? format(data.dataProcessamentoAte, 'MM-dd-yyyy 00:00:00')
        : null;
    });

    setPaginationParams(paginationTabParams);
    setFilterParams(newFilterParams);
    return newFilterParams;
  }

  function handleCheckBoxAllPagesReport(checkedAllpages) {
    setReportItems([]);
    setIsCheckedAllPages(checkedAllpages);
  }

  function handleSubmit(data) {
    const params = handleData(data);
    if (params) {
      setSearchBoxActive(true);
      dispatch(RequisicaoActions.postSegundaViaCartaoRequest(params));
    }
  }

  function handleFilterExtends() {
    setOpenFilterExtends(!openFilterExtends);
  }

  function handleInputChange(e) {
    setInputValue(e.target.value);
  }

  function handleModalProcess() {
    const isPendent = reportsItems.filter(
      (item) => item.statusDescription === 'Pendente'
    );

    if (isAfter(dataProcessamento, new Date())) {
      return toast.error(
        <WarningToast>
          A Data de processamento não deve ser superior à data atual.
        </WarningToast>
      );
    }

    if (reportsItems.length === 0) {
      return toast.error(
        <WarningToast>
          É necessário que pelo menos 1 solicitação seja selecionada.
        </WarningToast>
      );
    }

    if (isPendent.length === reportsItems.length) {
      return setOpenModalProcess({
        warning: !openModalProcess.warning,
        message: null,
        textHeader: 'cancelar',
        onClickOk: () => {
          ProcessDuplicate();
        },
      });
    }
    setReportItems([]);
    return toast.error(
      <WarningToast>
        É necessário que todas as solicitações estejam com status PENDENTE.
      </WarningToast>
    );
  }

  const handleChangePage = (paramsPag) => {
    if (paramsPag.pageNumber <= 0) {
      const newPaginationParams = produce(paginationParams, (draft) => {
        draft.pageNumber = 1;
        draft.pageSize = paramsPag.pageSize;
      });
      setPaginationParams(newPaginationParams);
    }

    const newFilterParams = produce(filterParams, (draft) => {
      draft.page = paramsPag.pageNumber <= 0 ? 0 : paramsPag.pageNumber - 1;
      draft.count_per_page = paramsPag.pageSize;
      draft.status = status === 99 ? null : status;
    });

    const params = {
      ...filterParams,
      ...newFilterParams,
    };
    setFilterParams(params);

    dispatch(RequisicaoActions.postSegundaViaCartaoRequest(newFilterParams));
  };

  function handleDropdownItemClick(item) {
    if (reportsItems.length === 0 && !isCheckedAllPages) {
      return toast.error(
        <WarningToast>
          Nenhuma solicitação de segunda via selecionada para a geração do
          relatório.
        </WarningToast>
      );
    }

    const statusName = {
      99: null,
      1: 'Pendente',
      2: 'Processado',
      4: 'Excluída',
      5: 'Não Processado',
    };

    if (isCheckedAllPages) {
      const newReportParams = produce(reportParams, (draft) => {
        draft.beneficiary_name = inputValue;
        draft.contractor_code = filterParams.contractor_code;
        draft.status = filterParams.status;
        draft.status_string = statusName[filterParams.status];
        draft.modality = filterParams.modality;
        draft.term_number = filterParams.term_number;
        draft.start_requisition_create_at =
          filterParams.start_requisition_create_at;
        draft.end_requisition_create_at =
          filterParams.end_requisition_create_at;
        draft.start_requisition_processing_date =
          filterParams.start_requisition_processing_date;
        draft.end_requisition_processing_date =
          filterParams.end_requisition_processing_date;
      });

      const params = {
        ...newReportParams,
        tipoRelatorio: item,
      };

      return dispatch(
        RequisicaoActions.postSolicitarRelatorioSegundaViaRequest(params)
      );
    }
    const newReportParams = produce(reportParams, (draft) => {
      draft.status = filterParams.status;
      draft.status_string = statusName[filterParams.status];
      draft.requisition_ids = reportsItems.map(
        (requisition) => requisition.requisitionId
      );
      draft.beneficiary_name = inputValue;
      draft.contractor_code = filterParams.contractor_code;
      draft.modality = filterParams.modality;
      draft.term_number = filterParams.term_number;
      draft.start_requisition_create_at =
        filterParams.start_requisition_create_at;
      draft.end_requisition_create_at = filterParams.end_requisition_create_at;
      draft.start_requisition_processing_date =
        filterParams.start_requisition_processing_date;
      draft.end_requisition_processing_date =
        filterParams.end_requisition_processing_date;
    });

    const params = {
      ...newReportParams,
      tipoRelatorio: item,
    };

    return dispatch(
      RequisicaoActions.postSolicitarRelatorioSegundaViaRequest(params)
    );
  }

  function downloadFile(base64, filename, mediaType) {
    const temp = `data:${mediaType};base64,${encodeURIComponent(base64)}`;
    const download = document.createElement('a');
    download.href = temp;
    download.download = filename;
    document.body.appendChild(download);
    download.click();
    document.body.removeChild(download);
  }
  const handleStatus = (status) => {
    setStatus(status);
    setSearchBoxActive(false);

    const newFilterParams = produce(filterParams, (draft) => {
      draft.status = status === 99 ? null : status;
      draft.page = 0;
      draft.count_per_page = 10;
    });
    setPaginationParams(paginationTabParams);
    setFilterParams(newFilterParams);
    dispatch(RequisicaoActions.postSegundaViaCartaoRequest(newFilterParams));
  };

  useEffect(() => {
    if (usuario.role !== 'Adm') {
      dispatch(
        RequisicaoActions.getPermissaoSegundaViaRequest(
          usuario.codigoContratante
        )
      );
    }
  }, [dispatch, usuario]);
  useEffect(() => {
    if (!postRelatorioSegundaVia.loading && postRelatorioSegundaVia.success) {
      if (postRelatorioSegundaVia.response.fileContents !== '') {
        downloadFile(
          postRelatorioSegundaVia.response.fileContents,
          postRelatorioSegundaVia.response.fileDownloadName,
          postRelatorioSegundaVia.response.contentType
        );

        handleCheckBoxAllPagesReport(false);
        dispatch(
          RequisicaoActions.postSolicitarRelatorioSegundaViaSuccess(
            false,
            false
          )
        );
      }
    }
  }, [postRelatorioSegundaVia.loading, postRelatorioSegundaVia.response]);

  useEffect(() => {
    if (postProcessarSegundaVia.response.success) {
      setOpenModalProcess({
        warning: false,
        message: '',
        textHeader: '',
        onClickOk: null,
      });
      setReportItems([]);
      dispatch(RequisicaoActions.postSegundaViaProcessarSuccess({}, false));
      dispatch(RequisicaoActions.postSegundaViaCartaoRequest(filterParams));
    }
  }, [postProcessarSegundaVia.success]);

  return (
    <Container>
      <FadeIn>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text="2ª via de cartão"
              color={theme.titleGray}
              fontSize={38}
              marginBottom={8}
            />

            <WrapperFlex
              percentageWidth={40}
              justifyEnd
              alignCenter
              marginSides={10}
              flexWrap
              gap={20}
              marginRight={1}
            >
              {getPermissaoSegundaVia.response === true && (
                <CanAccess
                  checkRole={{
                    ContratanteAlteracao:
                      TipoPerfilUsuarioEnum.returnNameForName
                        .ContratanteAlteracao,
                  }}
                  userRole={usuario.role}
                >
                  <Button
                    tipo="primary"
                    paddingTop={8}
                    paddingRight={8}
                    paddingBottom={8}
                    paddingLeft={8}
                    padding={8}
                    justifySpaceBetween
                    alignCenter
                    width={160}
                    font="16px unimed_slabregular"
                    onClick={() => setIsOpenModalPesquisarBeneficiario(true)}
                  >
                    <MdAdd color={theme.whiteDefault} />
                    nova solicitação
                  </Button>
                </CanAccess>
              )}
              <CanAccess
                checkRole={{
                  ContratanteAlteracao:
                    TipoPerfilUsuarioEnum.returnNameForName.Adm,
                }}
                userRole={usuario.role}
              >
                <Dropdown
                  margin={0}
                  options={optionsButtonRelatorios}
                  tipo="button"
                  height={40}
                  background={theme.greenDefault}
                  fontHeader="16px unimed_slabregular"
                >
                  <MdFileDownload size="20" color={theme.whiteDefault} />
                  Gerar relatório
                </Dropdown>
              </CanAccess>
            </WrapperFlex>
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              {
                path: '2ª via de cartão',
                onNavigate: () => history.push('/novo/segunda-via'),
              },
            ]}
          />
        </WrapperFlex>
        <Form onSubmit={handleSubmit}>
          <WrapperFlex fullWidth justifyStart alignStart row marginBottom={25}>
            <SearchBox
              onClick={handleFilterExtends}
              isPressed={openFilterExtends}
              placeholder="Pesquise por nome do beneficiário"
              onChange={handleInputChange}
              value={inputValue}
              cancelFilterExtendsOpen={cancelFilterExtendsOpen}
              IconFilter={MdFilterList}
              IconSearch={MdSearch}
            >
              <WrapperFlex justifyStart alignStart row flex marginBottom={105}>
                <FilterExtendsSegundaVia
                  setSearchBoxValue={setInputValue}
                  cleanFilterParams={cleanFilterParams}
                />
              </WrapperFlex>
            </SearchBox>
          </WrapperFlex>
        </Form>
        <StatusFilter
          status={[
            { id: 99, description: 'Todos' },
            { id: 1, description: 'Pendente' },
            { id: 2, description: 'Processado' },
            { id: 4, description: 'Excluída' },
            { id: 5, description: 'Não Processado' },
          ]}
          onStatusClick={handleStatus}
          activeStatus={status}
        />

        <WrapperFlex justifyStart alignCenter column>
          {!status && !searchBoxActive ? (
            <Text
              size={20}
              bold
              text="Ao menos um status deve ser selecionado para iniciar a pesquisa"
            />
          ) : (
            <TabTableListaSegundaVia
              setPaginationParams={setPaginationParams}
              paginationParams={paginationParams}
              handleChangePage={handleChangePage}
              reportsItems={reportsItems}
              setReportItems={setReportItems}
              handleCheckBoxAllPagesReport={handleCheckBoxAllPagesReport}
              isCheckedAllPages={isCheckedAllPages}
              handleDropdownItemClick={handleDropdownItemClick}
              setIsCheckedAllPages={setIsCheckedAllPages}
              status={status}
              setOpenModalProcess={handleModalProcess}
              handleDataProcessamento={handleDataProcessamento}
              dataProcessamento={dataProcessamento}
              filterParams={filterParams}
            />
          )}
        </WrapperFlex>
        <Modal
          onClick={() => {
            handleModalProcess();
          }}
          header={
            <WrapperFlex alignCenter column flex>
              <Text
                color="rgba(90,90,90,1)"
                font="normal normal 800 24px/43px unimed_slabbold"
                size={22}
                text="Processamento de 2ªvia"
              />
            </WrapperFlex>
          }
          isOpen={openModalProcess.warning}
          footer={
            <ModalCancelActionFooter
              onClick={() => {
                handleModalProcess();
              }}
              onClickOk={() => {
                openModalProcess.onClickOk();
              }}
              isLoading={postProcessarSegundaVia.loading}
            />
          }
        >
          {postProcessarSegundaVia.loading ? (
            <WrapperFlex column gap={10} alignCenter justifyCenter>
              <Text font="bold 20px" text="Processando..." />
              <LoadingSpinner />
            </WrapperFlex>
          ) : (
            <WrapperFlex padding={20} column justifyCenter alignCenter>
              <MdInfo size="50" color={theme.greenDefault} />
              <Text
                font="bold 20px"
                center
                text={`Você selecionou 
              ${
                reportsItems.length > 9
                  ? `${reportsItems.length}`
                  : `0${reportsItems.length}`
              } 
              solicitaç${
                reportsItems.length > 1 ? 'ões' : 'ão'
              } para processamento. `}
              />
              <Text font="bold 20px" text="Deseja continuar?" />
            </WrapperFlex>
          )}
        </Modal>

        <Modal
          header={
            <WrapperFlex alignCenter column flex>
              <Text
                color="rgba(90,90,90,1)"
                font="normal normal 800 24px/43px"
                size={22}
                text="Relatórios!"
              />
            </WrapperFlex>
          }
          isOpen={postRelatorioSegundaVia.loading}
          footer={<></>}
        >
          <WrapperFlex column gap={30} alignCenter justifyCenter>
            <Text
              size={20}
              font="normal normal 400"
              text="Relatório sendo gerado, aguarde..."
            />
            <LoadingSpinner />
          </WrapperFlex>
        </Modal>

        <ModalPesquisaBeneficiarioSegundaVia
          isOpen={isOpenModalPesquisarBeneficiario}
          onCloseModal={() => setIsOpenModalPesquisarBeneficiario(false)}
        />
      </FadeIn>
    </Container>
  );
}

const ModalCancelActionFooter = ({ onClick, isLoading, onClickOk }) => {
  return (
    <>
      <Button
        tipo="secondary"
        onClick={onClick}
        marginRight={14}
        type="button"
        justifyCenter
        alignCenter
        width={121}
        disabled={isLoading}
        font="16px unimed_slabregular"
      >
        Não
      </Button>
      <Button
        tipo="primary"
        onClick={onClickOk}
        marginLeft={14}
        type="button"
        justifyCenter
        alignCenter
        width={121}
        disabled={isLoading}
        font="16px unimed_slabregular"
      >
        Sim
      </Button>
    </>
  );
};

export default SegundaVia;
